"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailRequest = void 0;
var ProductDetailRequest = /** @class */ (function () {
    function ProductDetailRequest() {
    }
    return ProductDetailRequest;
}());
exports.ProductDetailRequest = ProductDetailRequest;
;
//# sourceMappingURL=productDetail.request.js.map